export default theme => ({
  cardMedia: {
    objectFit: 'fill !important' // Override cover property from Material UI which will display logos too wide
  }
});
